import React, { createContext, useContext, useState } from 'react';
import { HERO_SLIDES } from '../mock';

const SlideContext = createContext({
  index: 0,
  setIndex: () => {},
  total: HERO_SLIDES.length,
});

export function SlideProvider({ children }) {
  const [index, setIndex] = useState(0);
  return (
    <SlideContext.Provider value={{ index, setIndex, total: HERO_SLIDES.length }}>
      {children}
    </SlideContext.Provider>
  );
}

export function useSlide() {
  return useContext(SlideContext);
}
